import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n"; // Initialize i18next
import App from "./App"; // Versión completa con Tailwind
// import AppTailwind from "./AppTailwind"; // Versión simplificada con Tailwind
// import TestTailwind from "./TestTailwind"; // Test de Tailwind
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
